export const MEASUREMENTS_STATE = Object.freeze({
    START: "start",
    CONTINUE: "continue",
    FINISHED: "finished",
});


export const VISUAL_SEARCH_EVENT = Object.freeze({
    PRODUCT_VISITED: "product_visited",
    PRODUCT_ADDED_TO_CART: "product_added_to_cart",
    PRODUCT_VIEWED_FROM_CART: "product_viewed_from_cart",
    CHECKOUT_STARTED: "checkout_started",
    PURCHASE_COMPLETED: "purchase_completed",
});

export const VISUAL_SEARCH_STATE_KEY = 'visual-search-camera-state';